import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

import { useDialog } from '@/core/composables/useDialog'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'DialogManager'
},
  __name: 'DialogManager',
  setup(__props) {

const { dialog, closeDialog } = useDialog()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    (_unref(dialog))
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(dialog).component), _mergeProps({
          key: _unref(dialog).id
        }, { ..._unref(dialog).props, ..._unref(dialog).listeners }, { onClose: _unref(closeDialog) }), null, 16, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}
}

})